<template>
  <div class="edit_report_person">
    <EditItem
      v-for="item in list"
      :key="item.id"
      :info="item"
      @onEdit="handleToEditReporter"
      @onDelete="handleToDeleteReporter"
    />
    <div class="add_btn" @click="handleToAddReporter">
      <span>新增</span>
    </div>
  </div>
</template>

<script>
import EditItem from '../components/EditItem';
import { get, post } from "../commen/http";
export default {
  components: {
    EditItem
  },
  data() {
    return {
      list: []
    }
  },
  mounted() {
    this.fetchReportList();
  },
  methods: {
    // 获取上报人列表
    async fetchReportList() {
      const toast = this.$toast.loading({
        message: '加载中...',
        duration: 0
      })
      const res = await get({
        url: '/api/health/reporter'
      })
      if(res.code == 1) {
        this.list = res.data;
        toast.clear();
      }else {
        this.$toast({
          message: res.message,
          position: 'bottom'
        });
      }
    },

    // 点击跳转新增上报人
    handleToAddReporter() {
      let pid = this.list && this.list.length > 0 ? this.list[0].parent_id : ''
      this.$router.push({
        path: '/home',
        query: {
          type: 'ADD',
          parent: pid
        }
      })
    },

    // 点击跳转编辑页面
    handleToEditReporter(id) {
      this.$router.push({
        path: '/home',
        query: {
          type: 'REP',
          student: id
        }
      })
    },

    // 点击删除上报人
    handleToDeleteReporter(id) {
      this.$dialog({
        title: '删除',
        message: '若删除上报人，此人的上报记录不会被删除。您确认删除吗？',
        showCancelButton: true
      }).then( async () => {
        const res = await post({
          url: '/api/health/reporter_edit',
          data: {
            id: id,
            status: 2
          }
        })

        if(res.code == 1) {
          this.fetchReportList();
          this.$toast({
            message: '删除成功',
            position: 'bottom'
          });
        }else {
          this.$toast({
            message: res.message,
            position: 'bottom'
          });
        }
      }).catch(e => {});
    }
  }
}
</script>

<style scoped>
.edit_report_person {
  box-sizing: border-box;
  padding: .35rem .25rem 1.2rem .25rem;
}
.add_btn {
  position: fixed;
  left: 50%;
  margin-left: -3.21rem;
  bottom: .3rem;
  z-index: 5;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 6.42rem;
  height: .89rem;
  font-size: .34rem;
  color: #fff;
  background: linear-gradient(90deg, #1A8FFF 0%, #359EFF 100%);
  border-radius: .45rem;
}
</style>